import { FormGroup, FormBuilder } from '@angular/forms';
import { FormQua042Build } from './forms-build/form-qua042-build';

export class FormQua042 extends FormQua042Build {
    public CreateForm(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            centro_ensaque: ['', []],
            contrato_juridico: ['', []],
            numero_campo: ['', []],
            safra: ['', []],
            lote_origem: ['', []],
            processo_origem: ['', []],
            centro_campo: ['', []],
            centro_producao: ['', []],
            ordem_processo: ['', []],
            especie: ['', []],
            geracao: ['', []],
            hibrido_rnc: ['', []],
            lote_saida: ['', []],
            codigo_material: ['', []],
            tipo_tratamento: ['', []],
            peneira: ['', []],
            grupo_peneira: ['', []],
            validade: ['', []],
            safra_boletim: ['', []],
            total_sacos: ['', []],
            tipo_ensaque: ['', []],
            peso_sessenta_mil_sementes_impressao_kg: ['', []],
            linha_ensaque: ['', []],
            tamanho_da_sacaria: ['', []],
            data_ensaque: ['', []],
            num_sementes_saco: ['', []],
            num_sementes_saco_basica: ['', []],
            qtde_sacos_ou_kg: ['', []],
            peso_total_lote_kg: ['', []],
            codigo_embalagem: ['', []],
            quantidade_embalagens_un: ['', []],
            perdas_embalagens_erro_impressao: ['', []],
            perdas_embalagens_erro_mensagem: ['', []],
            perdas_embalagens_erro_costura: ['', []],
            perdas_embalagens_outras_ocorrencias: ['', []],
            qntd_embalagem_canguru: ['', []],
            total_perdas_embalagens: ['', []],
            inicio_ensaque: ['', []],
            termino_ensaque: ['', []],
            duracao_atividade_ensaque_h: ['', []],
            inicio_tratamento: ['', []],
            termino_tratamento: ['', []],
            duracao_atividade_tratamento_h: ['', []],
            status: ['', []],
            umidade_prc: ['', []],
            responsavel_pela_conferencia_lote: ['', []],
            responsavel_pelo_ensaque: ['', []],
            responsavel_pelo_apontamento: ['', []],
            silo_classificado_ou_big_bag: ['', []],
            silo_tratado_ou_psa: ['', []],
            turno_ensaque: ['', []],
            descarte_tratado_kg: ['', []],
            data_hora_apontamento: ['', []],
            observacao: ['', []],
            created_by: ['', []],
            controle_analise_et004: ['', []],
            origem_negocio: ['', []],
            offline: true,
            status_processo: ['', []],
            status_lote: ['', []],
            estimativa_pa: ['', []],
            peso_pa: ['', []],
            peso_mil_sementes: ['', []],
            data_conferencia_fisica: ['', []],
            safra_basica: ['', []]

        });
        return formulario;
    }
}
